module.exports = __webpack_public_path__ + "img/ball-right.042e298.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/ball-right.png
// module id = cxVF
// module chunks = 15